<template>
    <div class="custom-tags">
        <el-tag :key="tag" v-for="tag in dynamicTags" :closable="editable" :disable-transitions="false" @close="handleClose(tag)">
            {{tag}}
        </el-tag>
        <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
            @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
        </el-input>
        <el-button v-if="!inputVisible && editable" class="button-new-tag" size="small" @click="showInput">新增标签</el-button>
    </div>
</template>


<script>
export default {
    data() {
        return {
            dynamicTags: [],
            inputVisible: false,
            inputValue: ''
        };
    },
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        "data": function (val) {
            this.dynamicTags = JSON.parse(JSON.stringify(val))
        }
    },
    created() {
        this.dynamicTags = JSON.parse(JSON.stringify(this.data))
    },
    methods: {
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            this.$emit("handelChange", this.dynamicTags)
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
            this.$emit("handelChange", this.dynamicTags)
        }
    }
}
</script>

<style lang="scss" scoped>
.el-tag+.el-tag {
    margin-left: 10px;
    margin-bottom: 5px;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
</style>